
import axios from "@/axios.js"

export default {
  fetchItems({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/artisans")
        .then((response) => {
          commit('SET_ITEMS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchItemsWithInterventions({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/artisans_with_interventions")
        .then((response) => {
          commit('SET_ITEMS_WITH_INTERVENTIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchItemsFullName({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/fullNameArtisans")
        .then((response) => {
          commit('SET_ITEMS_FULL_NAME', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/artisan", item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(response.data.artisan, {id: response.data.artisan.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/artisan/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_ITEM', response.data.artisan)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeItem({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/artisan/${itemId}`)
        .then((response) => {
          commit('REMOVE_ITEM', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },




}
